"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cell_style_merger_1 = require("../merger/cell-style-merger");
/**
 * Tabular report view value styles resolver (without conditional formatting styles).
 *
 */
var SimpleCellStyleResolver = /** @class */ (function () {
    function SimpleCellStyleResolver(reportViewStyles) {
        this.reportViewStyles = reportViewStyles;
        this.resolvedStylesCache = new Map();
    }
    /**
     * Merges row and column styles by given branch indexes.
     * Styles priorities are:
     * 1. column measure style
     * 2. column category style
     * 3. row style
     *
     * @returns {TextStyleDto}
     */
    SimpleCellStyleResolver.prototype.resolveValueCellStyle = function (rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex) {
        if (!this.cachedStyleExists(rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex)) {
            var styles_1 = [];
            if (this.reportViewStyles.rowBranchStylesDto) {
                var rowCategoryStyleDto = this.reportViewStyles.rowBranchStylesDto[rowBranchIndex].categoriesStyle.get(rowCategoryPathHolderId);
                var rowValueStyle = rowCategoryStyleDto && rowCategoryStyleDto.valueStyle;
                if (rowValueStyle) {
                    styles_1.push(rowValueStyle);
                }
            }
            if (this.reportViewStyles.columnBranchStylesDto) {
                this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].categoriesStyle.forEach(function (columnCategoryStyleDto, id) {
                    if (columnCategoryStyleDto.valueStyle) {
                        styles_1.push(columnCategoryStyleDto.valueStyle);
                    }
                });
                var columnMeasureStyle = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle;
                if (columnMeasureStyle && columnMeasureStyle.valueStyle) {
                    styles_1.push(columnMeasureStyle.valueStyle);
                }
            }
            var resolvedStyle = cell_style_merger_1.CellStyleMerger.mergeTextStyles(styles_1);
            this.putStyleToCache(resolvedStyle, rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex);
        }
        return this.getCachedStyle(rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex);
    };
    /**
     * Merges column styles by given branch index.
     * Styles priorities are:
     * 1. column measure style
     * 2. column category style
     *
     * @returns {TextStyleDto}
     */
    SimpleCellStyleResolver.prototype.resolveValueCellStyleWithoutRowGrouping = function (columnBranchIndex) {
        if (!this.cachedStyleExists(-1, -1, columnBranchIndex)) {
            var styles_2 = [];
            if (this.reportViewStyles.columnBranchStylesDto) {
                this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].categoriesStyle
                    .forEach(function (columnCategoryStyleDto, id) {
                    if (columnCategoryStyleDto.valueStyle) {
                        styles_2.push(columnCategoryStyleDto.valueStyle);
                    }
                });
                var columnMeasureStyle = this.reportViewStyles
                    .columnBranchStylesDto[columnBranchIndex].measureStyle;
                if (columnMeasureStyle && columnMeasureStyle.valueStyle) {
                    styles_2.push(columnMeasureStyle.valueStyle);
                }
            }
            var resolvedStyle = cell_style_merger_1.CellStyleMerger.mergeTextStyles(styles_2);
            this.putStyleToCache(resolvedStyle, -1, -1, columnBranchIndex);
        }
        return this.getCachedStyle(-1, -1, columnBranchIndex);
    };
    /**
     * Return style for row grouping category item
     * @param {number} rowBranchIndex
     * @param {number} rowCategoryPathHolderId
     * @returns {TextStyleDto}
     */
    SimpleCellStyleResolver.prototype.resolveRowCategoryItemStyle = function (rowBranchIndex, rowCategoryPathHolderId) {
        var fakeColumnBranchIndex = -1;
        if (!this.cachedStyleExists(rowBranchIndex, rowCategoryPathHolderId, fakeColumnBranchIndex)) {
            var rowValueStyle = void 0;
            if (this.reportViewStyles.rowBranchStylesDto) {
                var rowCategoryStyleDto = this.reportViewStyles.rowBranchStylesDto[rowBranchIndex].categoriesStyle.get(rowCategoryPathHolderId);
                rowValueStyle = rowCategoryStyleDto && rowCategoryStyleDto.valueStyle;
            }
            this.putStyleToCache(rowValueStyle, rowBranchIndex, rowCategoryPathHolderId, fakeColumnBranchIndex);
        }
        return this.getCachedStyle(rowBranchIndex, rowCategoryPathHolderId, fakeColumnBranchIndex);
    };
    SimpleCellStyleResolver.prototype.cachedStyleExists = function (rowBranchIndex, rowCategoryPathHolderId, columnIndex) {
        return this.resolvedStylesCache.get(this.getCacheKey(rowBranchIndex, rowCategoryPathHolderId, columnIndex)) != null;
    };
    SimpleCellStyleResolver.prototype.getCachedStyle = function (rowBranchIndex, rowCategoryPathHolderId, columnIndex) {
        return this.resolvedStylesCache.get(this.getCacheKey(rowBranchIndex, rowCategoryPathHolderId, columnIndex));
    };
    SimpleCellStyleResolver.prototype.putStyleToCache = function (textStyle, rowBranchIndex, rowCategoryPathHolderId, columnIndex) {
        this.resolvedStylesCache.set(this.getCacheKey(rowBranchIndex, rowCategoryPathHolderId, columnIndex), textStyle);
    };
    SimpleCellStyleResolver.prototype.getCacheKey = function (rowBranchIndex, rowCategoryPathHolderId, columnIndex) {
        return columnIndex + "_" + rowBranchIndex + "_" + rowCategoryPathHolderId;
    };
    return SimpleCellStyleResolver;
}());
exports.SimpleCellStyleResolver = SimpleCellStyleResolver;
//# sourceMappingURL=simple-cell-style-resolver.js.map